import(/* webpackMode: "eager" */ "/codebuild/output/src2608450076/src/fash-creative/src/app/privacy-policy/page.tsx")